// removed by extract-text-webpack-plugin
module.exports = {"InputResponseTime":"_3dsMqF7eOwesYIkt8icH7H"};


//////////////////
// WEBPACK FOOTER
// ./src/layout/Dashboard/MainPanel/Overview/style.css
// module id = 2423
// module chunks = 0